import * as types from './ui-mutation-type';
import * as allTypes from '../mutation-type';

function initialState() {
  return {
    afficheFondNoir: false,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_AFFICHE_FOND_NOIR](state, afficheFondNoir) {
    state.afficheFondNoir = afficheFondNoir;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
};

const getters = {
  afficheFondNoir: state => {
    return state.afficheFondNoir;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
